import useTranslation from 'customHooks/translate';
import CurrencyFlag from 'react-currency-flags';

import { CURRENCY_CONFIG } from './currency-config';

const BalanceInCurrency = ({
  data,
  showTotals,
}: {
  data: any;
  showTotals: boolean;
}) => {
  const translation = useTranslation();

  if (!data) return null;

  const availableCurrencies = new Set<string>();

  if (Array.isArray(data)) {
    if (data.length > 0 && data[0] && typeof data[0] === 'object') {
      data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key.endsWith('Total')) {
            const currencyCode = key.replace('Total', '').toUpperCase();
            availableCurrencies.add(currencyCode);
          }
        });
      });
    }
  }
  if (availableCurrencies.size === 0 && Array.isArray(data)) {
    data.forEach((item, index) => {
      if (item && typeof item === 'object') {
        Object.keys(item).forEach((key) => {
          if (key.endsWith('Total')) {
            const currencyCode = key.replace('Total', '').toUpperCase();
            availableCurrencies.add(currencyCode);
          }
        });
      }
    });
  }

  const renderCurrencyCard = (currencyCode: string) => {
    const lowerCode = currencyCode.toLowerCase();
    const totalKey = `${lowerCode}Total`;
    const config = CURRENCY_CONFIG[currencyCode] || {
      symbol: currencyCode,
      name: currencyCode,
    };

    let mainValue: number = 0;
    let creditorValue: number = 0;
    let debitorValue: number = 0;

    if (showTotals && Array.isArray(data) && data.length >= 2) {
      debitorValue = data[0]?.[totalKey] || 0;
      creditorValue = data[1]?.[totalKey] || 0;
      mainValue = debitorValue - creditorValue;
    } else if (Array.isArray(data)) {
      const currencyItem = data.find(
        (item) => item && item[totalKey] !== undefined
      );
      mainValue = currencyItem?.[totalKey] || 0;
    } else if (data && typeof data === 'object') {
      mainValue = data[totalKey] || 0;
    }

    if (mainValue === 0 && creditorValue === 0 && debitorValue === 0) {
      return null;
    }

    return (
      <div
        key={currencyCode}
        className="flex h-max flex-col justify-between gap-[16px] rounded-[4px] bg-[#F5F7F9] p-[16px]"
      >
        <div className="flex flex-col gap-[4px]">
          <CurrencyFlag
            className="currency-flag mb-[10px]"
            currency={currencyCode}
          />
          <span className="text-[14px] font-normal text-gray-500">
            {currencyCode} {translation.dashboard.SideReport_BalancesAzn}
          </span>
          <span className="text-[18px] font-medium text-[#1d1d1d]">
            {new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(mainValue)}{' '}
            {config.symbol}
          </span>
        </div>

        <div>
          {showTotals && (creditorValue !== 0 || debitorValue !== 0) && (
            <div className="flex flex-col gap-[16px] font-medium">
              <div className="flex flex-col gap-[4px]">
                <p className="text-[14px] font-medium text-gray-500">
                  {translation.dashboard.SideReport_BalancesCrTot}:
                </p>
                {new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(debitorValue)}{' '}
                {config.symbol}
              </div>
              <div className="flex flex-col gap-[4px]">
                <p className="text-[14px] font-medium text-gray-500">
                  {translation.dashboard.SideReport_BalancesDrTot}:
                </p>
                {new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(creditorValue)}{' '}
                {config.symbol}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const currencyCards = Array.from(availableCurrencies)
    .sort()
    .map(renderCurrencyCard)
    .filter(Boolean);

  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-[10px] md:grid-cols-2">
      {currencyCards.length > 0 ? (
        currencyCards
      ) : (
        <div className="py-8 text-center text-gray-500">
          No currency data available
        </div>
      )}
    </div>
  );
};

export default BalanceInCurrency;
